"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaobabLogEventType;
(function (BaobabLogEventType) {
    BaobabLogEventType["Click"] = "click";
    BaobabLogEventType["Scroll"] = "scroll";
    BaobabLogEventType["Tech"] = "tech";
    BaobabLogEventType["Create"] = "show";
    BaobabLogEventType["Append"] = "append";
    BaobabLogEventType["Visibility"] = "visibility";
})(BaobabLogEventType = exports.BaobabLogEventType || (exports.BaobabLogEventType = {}));
var VisibilityChangeType;
(function (VisibilityChangeType) {
    VisibilityChangeType["Show"] = "show";
    VisibilityChangeType["Hide"] = "hide";
})(VisibilityChangeType = exports.VisibilityChangeType || (exports.VisibilityChangeType = {}));
function isTreeNode(value) {
    return 'key' in value;
}
exports.isTreeNode = isTreeNode;
function isChildNode(value) {
    return 'parent' in value;
}
exports.isChildNode = isChildNode;
function isRootNode(value) {
    return !('parent' in value);
}
exports.isRootNode = isRootNode;
